module.exports = __webpack_public_path__ + "img/rec-12.dbbd12ce.jpg";